import Api from '../Api';

import { url } from './config';
import { AmadeusGateway } from './types';

const api = new Api<AmadeusGateway>(url);

export default api;
